import React, { Component } from 'react';

import { Button } from 'devextreme-react/button';
import { Tooltip } from 'devextreme-react/tooltip';
import Box, { Item as BoxItem } from 'devextreme-react/box';
import AntLocalization from '../utils/AntLocalization';

export default function (props) {
    var hasDetails = props.errors instanceof Array && props.errors.length > 0;
    var errorDetails = (hasDetails ? props.errors.map((e) => AntLocalization.translateText(e)).join('\n') : '').split('\n');
    var errorId = props.id;
    var errorText = props.text;
    errorText = AntLocalization.translateText(errorText);

    return (
        <React.Fragment>
            {errorText && (
                <div className={props.hasBackground ? 'ant-error-pannel' : 'ant-error-text'}>
                    <Box direction="row" height="100%" width="100%">
                        <BoxItem baseSize={40}>
                            <Button
                                className="ant-grid-icon ant-icon-error"
                                id={errorId}
                                type="normal"
                                stylingMode="text"
                                focusStateEnabled={false}
                                hoverStateEnabled={false}
                                activeStateEnabled={false}
                            >
                                <i className={'dx-icon dx-icon-info'}></i>
                            </Button>
                        </BoxItem>

                        <BoxItem ratio={1}>
                            <span className="ant-error-text">{errorText}</span>
                        </BoxItem>
                    </Box>

                    {hasDetails && (
                        <Tooltip
                            target={`#${errorId}`}
                            className="ant-tooltip"
                            hideEvent="mouseleave"
                            showEvent={{
                                name: 'mouseenter dxclick keyup'
                            }}
                            hideOnOutsideClick={true}
                        >
                            {errorDetails.map((item, key) => {
                                if (key < errorDetails.length - 1)
                                    return (
                                        <React.Fragment>
                                            <label key={key}>{item}</label> <br />
                                        </React.Fragment>
                                    );
                                else return <label key={key}>{item}</label>;
                            })}
                        </Tooltip>
                    )}
                </div>
            )}
        </React.Fragment>
    );
}
